import React from "react"
import ReactDOM from "react-dom"
import SearchResult from "./component/common/searchResult"
//import * as serviceWorker from './serviceWorker';

import QueryString from "query-string"
import * as dataProvider from "./helpers/dataProvider"
import Typeahead from "./component/typeahead"

const queryParam = QueryString.parse(window.location.search)
export default class TypeAheadApp {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.desktopSearchBox = document.querySelector("[data-input-search]")
    self.elem.mobileSearchBox = document.querySelector("[data-mobile-input-search]")
    self.elem.searchInput = document.querySelector("[data-input-search]")
    self.elem.searchContainer = document.querySelector("[data-search-container]")
    self.elem.typeaheadContainer = elem.querySelector("[data-typeahead-container]")
    self.clearSearchFieldOnClose = true
    self.init()
    this.searchTimeout = null // Add timeout property
    return self
  }
  init() {
    const self = this
    if (self.elem.typeaheadContainer) {
      let config = self.elem.typeaheadContainer ? self.elem.typeaheadContainer.dataset.typeaheadContainer : ""
      if (config) {
        config = JSON.parse(config)
      }
      ReactDOM.unmountComponentAtNode(self.elem.typeaheadContainer)
      ReactDOM.render(
        <Typeahead useOriginalMarkup={false} config={config} eventCategory={"site search - generic"}></Typeahead>,
        self.elem.typeaheadContainer,
      )
    } else {
      const desktopSearchBox = self.elem.desktopSearchBox
      const mobileSearchBox = self.elem.mobileSearchBox
      const inputSearchBoxes = [desktopSearchBox, mobileSearchBox]
      let language = (document.body && document.body.dataset.language) || "da"
      let config = desktopSearchBox ? desktopSearchBox.dataset.inputSearch : ""
      if (config) {
        config = JSON.parse(config)
        language = config.language || language
      }
      if (inputSearchBoxes.length > 0) {
        inputSearchBoxes.forEach((element) => {
          if (element) {
            if (config) {
              element.placeholder = config.zeroState.searchDefaultText || "Søg."
            }
            element.addEventListener("input", (event) => this.handleSearch(event, true, language))
            element.addEventListener("focus", (event) => this.handleSearch(event, false, language))
            element.addEventListener("blur", (event) => this.handleRemoveSearch(event, language))
            if (queryParam.sq) {
              element.value = queryParam.sq
              element.dispatchEvent(new Event("input"))
            }
          }
        })
      }
    }
  }

  getDataConfig() {
    const self = this
    const input = self.elem.searchInput
    const container = self.elem.searchContainer

    if (input) {
      const config = input.dataset.inputSearch ? JSON.parse(input.dataset.inputSearch) : {}
      const isShop = config.isShop || false
      if (isShop) {
        container.classList.add("general-search-panel--taxfree")
      }
      return config
    }
  }

  handleRemoveSearch(event, language) {
    const { target } = event
    setTimeout(() => {
      if (target.parentElement.classList.contains("is-active")) {
        return
      } else {
        if (this.clearSearchFieldOnClose) {
          target.value = ""
        }
        this.handleSearch(event, true, language)
      }
    }, 100)
  }

  handleSearch = async (event, track = true, language = "da") => {
    const { target } = event
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(async () => {
      const response = await dataProvider.getData(target.value, language)
      if (response && response.data) {
        this.mountSearchResults(target.value, response.data, track)
      } else {
        this.mountSearchResults(target.value, {}, track)
      }
    }, 400)
  }

  mountSearchResults = (searchQuery, data, track = true) => {
    const self = this
    const eventCategory = "site search - generic"
    const searchResultContainer = self.elem.searchContainer
    const { filteredData, displayGroupNames, totalCount } = dataProvider.createPageData(data, this.getDataConfig(), track, eventCategory, searchQuery)
    if (searchResultContainer) {
      ReactDOM.unmountComponentAtNode(searchResultContainer)
      ReactDOM.render(
        <SearchResult
          dataConfig={this.getDataConfig()}
          data={filteredData}
          displayGroupNames={displayGroupNames}
          totalCount={totalCount}
          searchQuery={searchQuery}
          eventCategory={eventCategory}
        ></SearchResult>,
        searchResultContainer,
      )
    }
  }

  // getData = query => {
  //   if (query.length > 1)
  //     return http.get(config.siteprefix + config.url + query);
  // }

  // createPageData = (data) => {
  //   const self = this
  //   const displayGroupNames = {}
  //   if(data) {
  //     for (var propName in data) {
  //       displayGroupNames[propName] = data[propName].displayGroupName
  //       if (data[propName].count === 0) {
  //         data[propName].docs = self.createZeroStateData(data[propName].docs, propName);
  //         //delete data[propName];
  //       }
  //     }
  //     return { filteredData: data, displayGroupNames: displayGroupNames};
  //   }
  //   return { filteredData: {}, displayGroupNames: displayGroupNames};
  // };

  // createZeroStateData = (docs, propName) => {
  //   const desktopSearchBox = document.querySelector('[data-input-search]')
  //   let config = desktopSearchBox ? desktopSearchBox.dataset.inputSearch : ''
  //   if(config) {
  //     config = JSON.parse(config)
  //   }
  //   if(docs && docs.length > 0) {
  //     return docs.map(element => {
  //       element.name = config.zeroState.data[propName] ? config.zeroState.data[propName].name : ''
  //       element.url = config.zeroState.data[propName] ? config.zeroState.data[propName].url : ''
  //       element.displayGroupName = config.zeroState.data[propName] ? config.zeroState.data[propName].displayGroupName : ''
  //       return element
  //     })
  //   } else {
  //     // let typeahead = {}
  //     let zeroDataDocs = []
  //     if(config.zeroState.data[propName]) {
  //       zeroDataDocs = config.zeroState.data[propName].map(element => {
  //         element.isZeroData = true
  //         return element
  //       })
  //     }

  //     docs = zeroDataDocs
  //     // element.name = config.zeroState.data[propName] ? config.zeroState.data[propName].name : ''
  //     //   element.url = config.zeroState.data[propName] ? config.zeroState.data[propName].url : ''
  //     //   element.displayGroupName = config.zeroState.data[propName] ? config.zeroState.data[propName].displayGroupName : ''
  //     // docs.push(element)
  //     return docs

  //   }
  // }

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  // serviceWorker.unregister();
}
//window.typeAheadApp = new TypeAheadApp()
